import { window } from '../../../globals';
import { queryClient } from '../../../ReactQuery';
import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { fileUpload } from '../../../redux/api';

type UploadLogoParams = {
  organizationId: number;
  file: File;
};

async function uploadOrganizationLogo({ organizationId, file }: UploadLogoParams): Promise<void> {
  await fileUpload(`/api/organizations/${organizationId}/logo/upload`, file, 'logo');
}

/**
 * Hook for uploading organization logo using the new streaming endpoint.
 */
export default function useUploadOrganizationLogo() {
  return useToastedMutation({
    mutationFn: uploadOrganizationLogo,
    successToastMessage: 'Logo uploaded successfully',
    errorToastMessage: 'Failed to upload logo',
    onSuccess: (_, variables) => {
      if (window.user && window.user.organization) {
        window.user.organization.image = variables.file.name;
      }
      queryClient.invalidateQueries({ queryKey: ['organization'] });
    },
  });
}
